import * as React from 'react'
import styled from 'styled-components'
import {theme} from '../theme'

interface IProps {
  className?: string
  value?: string | number | null
  label?: string
  placeHolder?: string
  onChange: (value: string) => void
  rows?: number
  width?: string
  charLimit?: number
}
class TextAreaClass extends React.PureComponent<IProps> {
  static defaultProps: Pick<IProps, 'rows'> = {
    rows: 4
  }
  private onChange = (event: any) => {
    if ((this.props.charLimit && event.target.value.length <= this.props.charLimit) || !this.props.charLimit) {
      this.props.onChange(event.target.value)
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.props.label && <label>{this.props.label}</label>}
        <TextAreaElement
          className={this.props.className}
          value={this.props.value || ''}
          placeholder={this.props.placeHolder}
          onChange={this.onChange}
          rows={this.props.rows}
        />
        {this.props.charLimit && (
          <CharLimit>
            Vastauksen pituus: {this.props.value ? this.props.value.toString().length : 0}/{this.props.charLimit}
          </CharLimit>
        )}
      </div>
    )
  }
}

const TextAreaElement = styled.textarea`
  margin-top: 7px;
  margin-bottom: 0 !important;
  display: block;
  border: 1px solid ${theme.color.darkGray};
  box-shadow: none;
  border-radius: 4px;
  width: 100%;
  font-size: ${theme.fontSize.small};
  padding: 0.8rem;
  background-color: #fff;
  color: #000;
  &::placeholder {
    color: ${theme.color.gray};
  }
  &:focus {
    outline: 0;
  }
  resize: none;
`

const CharLimit = styled.p`
  font-size: ${theme.fontSize.xsmall};
  margin: 5px 0 0 3px;
`

export const TextArea = styled(TextAreaClass)`
  width: ${props => props.width || '100%'};
  @media screen and (max-width: ${theme.breakPoints.mobileLandscape}px) {
    width: 100%;
  }
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    width: 100%;
  }
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    label {
      font-size: 1.5rem;
    }
  }
`
